import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatButtonToggleChange, MatSlideToggleChange} from '@angular/material';

@Component({
  selector: 'app-ngx-medium-toggle',
  templateUrl: './ngx-medium-toggle.component.html',
  styleUrls: ['./ngx-medium-toggle.component.css']
})
export class NgxMediumToggleComponent implements OnInit {

  @Output()
  onValueChange: EventEmitter<MatSlideToggleChange> = new EventEmitter<MatSlideToggleChange>();

  @Input()
  checked;

  @Input()
  title: string;

  constructor() { }

  ngOnInit() {
  }

}
